import { IPageData, IPageParams } from "../types"
import { E_SensorKlass } from "./sensor.types"

/**
 * $t('enum.E_EquipmentRunStatus.Open')
 * $t('enum.E_EquipmentRunStatus.Stop')
 * $t('enum.E_EquipmentRunStatus.Disabled')
 */
export enum E_EquipmentRunStatus {
    /**
     * 开机
     */
    Open = 1,
    /**
     * 停机
     */
    Stop = 2,
    /**
     * 停用
     */
    Disabled = 3,
}

export interface IEquipmentRunThresholdEditEquipmentAlarmParams {
    equipmentIds: number[]
    thresholdValue: number
}

export interface IEquipmentRunThresholdEditMappingAlarmParams {
    mappingIds: number[]
    thresholdValue?: number
    temRunThresholdMax?: number
    temRunThresholdMin?: number
}

export type IEquipmentRunThresholdQueryRunStatisticsParams = Partial<{
    companyId
    areaId
    endTime
    equipmentName
    equipmentTypeIds: number[]
    runStatus: E_EquipmentRunStatus
    startTime
}>

export interface IEquipmentRunThresholdQueryRunStatisticsData {
    runNum: number
    stopNum: number
}


export interface IRunListItem {
    companyId
    companyName
    areaId
    areaName
    createTime
    equipmentId
    equipmentName
    equipmentTypeId
    equipmentTypeName
    runRate: number
    runStatus: E_EquipmentRunStatus
    runTime: number
    stopTime: number
}

export type IEquipmentRunThresholdQueryRunListParams = IPageParams & IEquipmentRunThresholdQueryRunStatisticsParams

export type IEquipmentRunThresholdQueryRunListData = IPageData<IRunListItem>

export type IEquipmentRunThresholdQueryRunMappingListParams = IPageParams & {
    equipmentId
}

export interface IRunMappingListItem {
    createTime
    equipmentId
    equipmentName
    isOnline
    mappingId
    mappingName
    runStatus
    runThreshold
    sensorId
    sensorType: E_SensorKlass

    temRunThresholdMax
    temRunThresholdMin
}

export type IEquipmentRunThresholdQueryRunMappingListData = IPageData<IRunMappingListItem>

